import React, { useEffect, useState } from "react";
import axiosInstance from "../../api";
import "../../css_files/Technician/LocationRequests.css";
import CloseForm from "../Master/CloseForm";
import moment from "moment";
import Pagination from "../Homepage/Pagination";
import { toast } from "react-toastify";

function LocationRequests({ setshowlocationrequests, set_refresh, re_fresh }) {
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [requestloader, setrequestloader] = useState([]);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/LocationRequest/ShowAllLocationRequests/${pagenumber}`
      )
      .then((res) => {
        setdata(res.data?.data);
        setpagecount(res.data?.pages);
        setrequestloader(
          Array.from({ length: res.data?.data?.length }, () => false)
        );
        setloading(false);
      })
      .catch(console.log);
  }, [refresh, pagenumber]);

  function handleSubmit(data, status, index) {
    setrequestloader((prev) => prev.map((_, j) => j === index));
    axiosInstance
      .put(
        `${process.env.REACT_APP_API_URL}/api/LocationRequest/UpdateLocationRequest`,
        {
          Id: data?.id,
          Status: status,
        }
      )
      .then((res) => {
        axiosInstance
          .put(
            `${process.env.REACT_APP_API_URL}/api/LocationHistory/UpdateLocationHistory`,
            {
              Id: data?.locationId,
              ActualEndTime: data?.markedDateTime,
              VisitStatus: status,
            }
          )
          .then((res) => {
            setrefresh(!refresh);
            setrequestloader((prev) => prev.map((_) => false));
            set_refresh(!re_fresh);
            toast.success(res?.data, {
              position: "bottom-center",
            });
          })
          .catch(console.log);
      })
      .catch(console.log);
  }

  return (
    <section className="technician-location-request">
      <div>
        {loading ? (
          <i className="fa-solid fa-spinner fa-spin fa-2x" />
        ) : data?.length > 0 ? (
          data?.map((x, i) => (
            <aside key={i}>
              <p>
                <strong>Ticket Id: </strong>
                {x?.locationHistory?.ticket?.seriesId}
              </p>
              <p>
                <strong>From Location: </strong>
                {`${x?.locationHistory?.fromLocationLatitude}, ${x?.locationHistory?.fromLocationLongitude}`}
              </p>
              <p>
                <strong>Destination Location: </strong>
                {`${x?.locationHistory?.toLocationLatitude}, ${x?.locationHistory?.toLocationLongitude}`}
              </p>
              <p>
                <strong>Actual Location: </strong>
                {`${x?.latitude}, ${x?.longitude}`}
              </p>
              <p>
                <strong>Start Time: </strong>
                {moment(x?.locationHistory?.startTime).format(
                  "DD/MM/YYYY HH:mm:ss"
                )}
              </p>
              <p>
                <strong>Expected End Time: </strong>
                {moment(x?.locationHistory?.expectedEndTime).format(
                  "DD/MM/YYYY HH:mm:ss"
                )}
              </p>
              <p>
                <strong>Actual End Time: </strong>
                {moment(x?.markedDateTime).format("DD/MM/YYYY HH:mm:ss")}
              </p>
              <p>
                <strong>Technician User Id: </strong>
                {x?.locationHistory?.technician?.userID}
              </p>
              <p>
                <strong>Customer Name: </strong>
                {x?.locationHistory?.ticket?.newEnquiry?.customer?.orgName}
              </p>
              <p>
                <strong>Product Name: </strong>
                {
                  x?.locationHistory?.ticket?.newEnquiry?.customerBoiler?.boiler
                    ?.head
                }
                -
                {
                  x?.locationHistory?.ticket?.newEnquiry?.customerBoiler
                    ?.boilerSeriess?.seriesCode
                }
              </p>
              <p>
                <strong>Current Status: </strong>
                {x?.status}
              </p>
              {x?.status === "Pending" && (
                <blockquote>
                  <button
                    onClick={() => {
                      handleSubmit(x, "Approved", i);
                    }}
                    disabled={requestloader[i]}
                  >
                    {requestloader[i] ? "Please Wait..." : "Approve"}
                  </button>
                  <button
                    onClick={() => {
                      handleSubmit(x, "Rejected", i);
                    }}
                    disabled={requestloader[i]}
                  >
                    {requestloader[i] ? "Please Wait..." : "Reject"}
                  </button>
                </blockquote>
              )}
            </aside>
          ))
        ) : (
          <p>No Location Requests Found</p>
        )}
        <CloseForm close={setshowlocationrequests} />
        <Pagination
          count={pagecount}
          setpagenumber={setpagenumber}
          pagenumber={pagenumber}
        />
      </div>
    </section>
  );
}

export default LocationRequests;
